import BookmarkStorage from "./BookmarkStorage";

/*
  Watch for rendered buttons and attached event handlers to create bookmark storage
*/
export default class BookmarkButtons extends BookmarkStorage {
  config = {
    buttonClass: ".bookmark_button",
    activeClass: "active",
    dataAttribute: "data-bookmark",
  };
  constructor(config) {
    super();
    this.config = { ...this.config, ...config };
    this.init();
  }

  init = () => {
    // Add event listeners
    this.buttonElements = document.querySelectorAll(this.config.buttonClass);

    // the bookmark buttons
    if (this.buttonElements) {
      this.buttonElements.forEach((input) => {
        if (input.getAttribute("listener") !== "true") {
          input.setAttribute("listener", "true");
          input.addEventListener("click", this.handleClick.bind(this));
        }
      });
    }

    // check if a card is bookmarked and toggle the class on load
    this.checkIsBookmarked();
  };

  handleClick = (event) => {
    event.preventDefault();
    // this is now the input element
    let data = event.target.dataset.bookmark;

    if (data) {
      // parse the base64 into json object
      data = JSON.parse(atob(data));

      // toggle the object in storage
      var added = this.toggleBookmark(data);

      // toggle the active class
      this.toggleActive(event.target, added);

      // add a recent article to local storage when button bookmark button is clicked
      if (this.isBookmarked(data.id)) {
        // create a notification
        if (window.squiz?.vars?.bookmarkNotification) {
          const config = {
            content: `${data.name} has been bookmarked.`,
            active: true,
            theme: "sand",
            toFront: true,
            forBookmark: true,
            timeout: 5000,
          };
          new window.squiz.fn.Notification(config);
        }

        // add to recent articles list
        window.squiz.fn.ArticleStorage.updateArticle(
          event.target,
          this.config.dataAttribute,
        );
      } else {
        if (window.squiz?.vars?.bookmarkNotification) {
          const config = {
            content: `${data.name} has been removed from your bookmarks.`,
            active: true,
            theme: "sand",
            toFront: true,
            forBookmark: true,
            timeout: 5000,
          };
          new window.squiz.fn.Notification(config);
        }
      }
    }
  };

  // iterate through cards if they exist and update the is bookmarked classes
  checkIsBookmarked() {
    if (this.buttonElements.length) {
      this.buttonElements.forEach((e) => {
        let data = e.dataset.bookmark;
        if (data) {
          data = JSON.parse(atob(data));
          if (this.isBookmarked(data?.id)) {
            this.toggleActive(e, true);
          } else {
            this.toggleActive(e);
          }
        }
      });
    }
  }
}
